import React from "react";
import { Box, Stack, Typography, TextField } from "@mui/material";
import { WEEK_DAYS } from "../../../constants/recurrenceConstants";

const WeeklyPicker = ({ values, set, errors }) => {
  const toggle = (day) => {
    const current = values.recurrenceDaysOfWeek || [];
    const next    = current.includes(day)
      ? current.filter((d) => d !== day)
      : [...current, day].sort((a, b) => a - b);
    set("recurrenceDaysOfWeek", next);
  };

  return (
    <Box>
      <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#475569" }}>
          Repeat every
        </Typography>
        <TextField
          type="number"
          size="small"
          value={values.recurrenceInterval}
          onChange={(e) => set("recurrenceInterval", Math.max(1, parseInt(e.target.value) || 1))}
          inputProps={{ min: 1, max: 52 }}
          sx={{ width: 70 }}
        />
        <Typography sx={{ fontSize: "13px", color: "#64748B", fontWeight: 500 }}>
          week{values.recurrenceInterval !== 1 ? "s" : ""} on
        </Typography>
      </Stack>

      <Stack direction="row" gap={1} flexWrap="wrap">
        {WEEK_DAYS.map(({ value, label }) => {
          const selected = (values.recurrenceDaysOfWeek || []).includes(value);
          return (
            <Box
              key={value}
              onClick={() => toggle(value)}
              sx={{
                width: 40, height: 40,
                display: "flex", alignItems: "center", justifyContent: "center",
                borderRadius: "50%",
                border: `2px solid ${selected ? "#0D9488" : "#E2E8F0"}`,
                bgcolor: selected ? "#0D9488" : "#fff",
                color:   selected ? "#fff"    : "#64748B",
                fontSize: "12px", fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.15s",
                userSelect: "none",
                "&:hover": { borderColor: "#0D9488", color: selected ? "#fff" : "#0D9488" },
              }}
            >
              {label}
            </Box>
          );
        })}
      </Stack>

      {errors.recurrenceDaysOfWeek && (
        <Typography sx={{ fontSize: "11px", color: "#EF4444", mt: 1 }}>
          {errors.recurrenceDaysOfWeek}
        </Typography>
      )}
    </Box>
  );
};

export default WeeklyPicker;
